import { getUniqueKey } from "./KeyUtils";

export const getNoCache = (): string => {
  return getUniqueKey();
};
